import { combineReducers } from 'redux';
import statistics from './statistics';
import transactions from './transactions';
import items from './items';

export default combineReducers({ statistics, transactions, items });
